import { useQuery } from '@apollo/client/react'
import Spinner from '~/components/Spinner'
import { GQL_LEARNER_POSITIONING } from '~/gql/positioning/positioning'
import ProfilePositioning from './ProfilePositioning'

/** Le positionnement de l'apprenant (#321), chargé à part comme ses autres blocs. */
function LearnerPositioning({ userId }: { userId: string }) {
  const { data } = useQuery(GQL_LEARNER_POSITIONING, { variables: { userId }, fetchPolicy: 'cache-and-network' })
  if (!data) return <Spinner className="mx-auto size-6 text-muted-foreground" />
  return <ProfilePositioning sessions={data.learnerPositioning} />
}

export default LearnerPositioning
